<script>
import { get } from 'lodash'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.items)) {
        this.$set(this.form, 'items', [])
      }
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Header({
              type: 'h3',
              text: 'Gallery items'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((itemGallery, i) => {
                return {
                  headerLabel: 'Item',
                  fields: [
                    new fields.Input({
                      label: 'Caption',
                      modelPath: [this, 'form', 'items', i, 'caption'],
                      multilingual: true
                    }),
                    new fields.Image({
                      label: 'Image',
                      modelPath: [this, 'form', 'items', i, 'image'],
                      required: true,
                      onlyShowGalleryCrop: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
